/**
 * Resolve an image value from the API into a usable <img src>.
 * Supports both formats:
 * - Blob Storage URL (after image migration): returned as-is
 * - Legacy Base64 string: wrapped in a data URI
 */
export const getImageSrc = (image?: string | null): string => {
  if (!image) return '';
  if (image.startsWith('http://') || image.startsWith('https://')) return image;
  return `data:image/png;base64,${image}`;
};
